import type { NextPage } from "next";
import Link from "next/link";
const HowGurucoolWorks: NextPage = () => {
  return (
    <section className="section">
      <div className="innerDiv section pt-28 sm:pt-36 lg:pt-40 pb-0 sm:pb-4 lg:pb-10">
        <div className="mb-8">
          <h2 className="underline xs:text-2xl sm:text-3xl md:text-4xl pb-8 font-semibold">
            How our business works
          </h2>

          {/* Point 1 */}
          <div className="mb-12">
            <div className="flex">
              <h2 className="text-primaryColor font-medium mb-1 xs:text-xl sm:text-2xl ">
                Ads help fund our products
              </h2>
            </div>

            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              Our mission to democratise the world’s education and make it
              universally accessible and empathetic has always been core to
              everything we do at Gurucool. It’s why we make our product Padhaai
              accessible and free of charge to everyone.
            </p>
            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              Advertising is what makes it possible to offer our products to
              everyone. While we sell things like Tuition subscriptions and
              tools for learners and educators, we make the vast majority of our
              money from advertising.
            </p>
            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              So how does advertising at Gurucool work? We make money selling ad
              space to businesses -- big and small, global and local -- in two
              key ways. First, businesses can reach potential customers by
              showing ads on Gurucool Eduverse.
            </p>
            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              Second, businesses can buy ad space that we show on sites and apps
              that partner with us. In this case, most of the money goes to the
              partner and helps fund their content. So ads not only help support
              Gurucool but also many other educators and creators.
            </p>
            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              Ultimately, we earn the most of our money by showing ads alongside
              relevant content on Gurucool.xyz. If you’re interested, you can
              learn more about
              <Link href={"#"}>
                <a className="underline text-blue-400"> how we make money with advertising.</a>
              </Link>
            </p>
          </div>
          {/* Point 2 */}
          <div className="mb-12">
            <div className="flex">
              <h2 className="text-primaryColor font-medium mb-1 xs:text-xl sm:text-2xl ">
                We don’t sell your personal information to anyone
              </h2>
            </div>

            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              We use your personal information to make our products more helpful
              to you. It’s how we can autocomplete your searches, help you learn
              better with Courses, or show you more useful Bits based on your
              interests. But we never sell your personal information to anyone
              and you can use many of our products without signing in or saving
              any personal information at all.
            </p>

            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              When we show ads, advertisers pay us either for the placement of
              an ad -- like a banner at the top of a web page -- or for how an
              ad actually performs -- like when someone clicks on it.
              Advertisers do not pay us for personal information, such as your
              name or email; we never share that information with advertisers
              unless you ask us to. We also never use your emails, documents,
              photos, or sensitive information like race, religion, or sexual
              orientation, to personalize ads to you. We share reports with our
              advertisers to help them understand the performance of their ads,
              but we do so without revealing any of your personal information.
              At every point in the process of showing you ads, we keep your
              personal information protected with
              <Link href={"#"}>
                <a className="underline text-blue-400"> industry-leading security technologies.
                </a>
              </Link>
            </p>
          </div>
          {/* Point 2 */}
          <div className="mb-12">
            <div className="flex">
              <h2 className="text-primaryColor font-medium mb-1 xs:text-xl sm:text-2xl ">
                Your data, your choice
              </h2>
            </div>

            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              When it comes to privacy, we know one size doesn’t fit all. That’s
              why we build powerful, easy-to-use privacy controls into your
              Gurucool Account and directly into our products so you can choose
              the privacy settings that are right for you.
            </p>

            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              When we show you ads we give you transparency and controls so you
              can make informed decisions. If you’re curious why you’re seeing a
              given ad, you can select Why this ad for more information. If you
              no longer find a specific ad relevant, you can mute it. You can
              use Ad Settings to control the information about you that’s used
              to show ads. And if you don’t want to see personalized ads at all,
              you can turn them off at any time.
            </p>
            <p className="mb-4 text-[#495057] xs:text-base xs:leading-8 sm:text-lg sm:leading-10 md:text-xl md:leading-10">
              Because of advertising, we’re able to offer our products to users
              around the world free of charge, helping people find answers and
              get things done. But, when you use our products you trust us with
              your personal information. That’s why we never sell your personal
              information and why we give you powerful privacy controls. It’s a
              responsibility that comes with creating products that are
              accessible for everyone, everywhere.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowGurucoolWorks;
